// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"42":"616961a4","325":"bfc82fb1","453":"1d47eaf6","482":"ec59b49a","810":"633e5c6c","944":"c50d9eb3"}[chunkId] + ".chunk.js";
};